import React, {useEffect } from 'react';
import { DataGridPro, LicenseInfo } from '@mui/x-data-grid-pro';
import Box from '@mui/material/Box';
import { IconButton } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

LicenseInfo.setLicenseKey('17ca2e8476fa658618680f9f135dbc81T1JERVI6MzU2MTYsRVhQSVJZPTE4NzMzODQyMDIwMDAsS0VZVkVSU0lPTj0x',);


export default function ShortDataGrid(props) {
    const { 
        apiRef, columns, getRowClassName, rows,
        hideFooter=false,
        onCellEditStop=() => {}, onProcessRowUpdateError=() => {}, processRowUpdate=() => {}
    } = props


    return (
        <DataGridPro 
            sx={{
                bgcolor: "rgba(0,0,0,0.9)",
                boxShadow: 2,
                border: 0,
                '& .MuiDataGrid-row.row--delete':{
                    backgroundColor: 'rgba(255, 0, 0, 0.2)',
                },
                '& .MuiDataGrid-row.row--edit':{
                    backgroundColor: 'rgba(16, 39, 58, 1)',
                },
                '& .MuiSvgIcon-root': {
                    color: "rgba(178, 186, 194, 0.4)"
                },
                '& .MuiDataGrid-footerContainer': {
                    borderTop: "1px solid rgba(224, 224, 224, 0.8)"
                },
                '& .MuiDataGrid-overlay': {
                    backgroundColor: "rgba(255, 255, 255, 0.01)"
                },
                '& .MuiDataGrid-row.Mui-selected': {
                    backgroundColor: "rgba(36, 108, 164, 0.35)",
                },
                '& .MuiDataGrid-columnHeaderTitle': {
                    color: "rgb(255, 255, 255)",
                    fontWeight: "bold",
                },
                '& .MuiDataGrid-columnHeadersInner': {
                    backgroundColor: "rgba(0, 0,0 , 0.1)",
                },
                '& .MuiDataGrid-pinnedColumns': {
                    backgroundColor: "#1c2025",
                    backgroundImage: 'none',
                    
                    boxShadow: '0px 3px 1px -2px rgb(0 0 0 / 50%), 0px 2px 2px 0px rgb(0 0 0 / 40%), 0px 1px 5px 0px rgb(36 108 164 / 90%)',
                },
                '& .MuiDataGrid-pinnedColumnHeaders': {
                    backgroundColor: "rgb(40,44,52)",
                    backgroundImage: 'none',
                    boxShadow: 'none',
                    borderColor: "rgba(77, 78, 82, 0.7)",
                },              
                '& .MuiDataGrid-cell': {
                color: "rgb(255, 255, 255)",
                borderColor: "rgba(77, 78, 82, 0.7)",
                },
                '& .MuiDataGrid-virtualScroller': {
                    flex: "1 1 0px",
                    overflow: "auto"
                },
            }}
            apiRef={apiRef}
            columns={columns}
            getRowClassName={getRowClassName}
            hideFooter={hideFooter}
            onCellEditStop={onCellEditStop}
            onProcessRowUpdateError={onProcessRowUpdateError}
            pageSize={4}
            processRowUpdate={processRowUpdate}
            rows={rows}
            disableRowSelectionOnClick
        />
    )
 }
